import React, { Component } from 'react'
import CloseIcon from 'grommet/components/icons/base/Close'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { setSectionProperty } from '../../actions/sections/SectionsActions'
import './SlideUpMenu.css'

@connect((state) => ({
  slideUpMenuOpen: state.sectionsReducer.slideUpMenu.open
}), { setSectionProperty })
class SlideUpMenu extends Component {

  handleClick = () => {
    const { setSectionProperty } = this.props
    setSectionProperty('slideUpMenu', 'open', false)
    setSectionProperty('overlay', 'isVisible', false)
  }

  render() {
    const { slideUpMenuOpen } = this.props
    const className = `SlideUpMenu${ slideUpMenuOpen ? ' is-visible' : ''}`
    return (
      <div className={className} style={this.props.style}>
        <div className="SlideUpMenu-container">
          <div onClick={this.handleClick} className="SlideUpMenu-closeIcon">
            <CloseIcon />
          </div>
          <Link className="SlideUpMenu-link" onClick={this.handleClick} to="/#agency"><span>Home</span></Link>
          <Link className="SlideUpMenu-link" onClick={this.handleClick} to="/#about"><span>About</span></Link>
          <Link className="SlideUpMenu-link" onClick={this.handleClick} to="/#creative-development"><span>Creative Development</span></Link>
          <Link className="SlideUpMenu-link" onClick={this.handleClick} to="/#ready-to-start"><span>Contact</span></Link>
        </div>
      </div>
    )
  }
}

export default SlideUpMenu


// WEBPACK FOOTER //
// ./src/components/SlideUpMenu/index.js